<div class="wrapper">
  <span class="text" *ngIf="isVisible" [ngStyle]="{ left: margin + 'px' }">{{
    text
  }}</span>
</div>
